import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconStatusbarMouseLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeMiterlimit: 1.5,
	clipRule: "evenodd",
	viewBox: "0 0 32 44",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 3.12,
		d: "M1.563 21.869v8.913a11.38 11.38 0 0 0 11.405 11.405h5.314a11.38 11.38 0 0 0 11.406-11.405V12.968A11.38 11.38 0 0 0 18.282 1.563h-2.657"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "nonzero",
		d: "M12.5 0C5.554.264 0 5.968 0 12.96v5.79h12.5z"
	})]
});
export default SvgIconStatusbarMouseLeft;
